import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const Pounds: ConvertableUnit = {
  label: "lbs",
  toStandardUnit: lbs => lbs,
  toThisUnit: lbs => lbs
};

export const Kilograms: ConvertableUnit = {
  label: "kg",
  toStandardUnit: kg => kg / 0.45359237,
  toThisUnit: lbs => lbs * 0.45359237
};

export const MetricTon: ConvertableUnit = {
  label: "mt",
  toStandardUnit: mt => (mt * 1000) / 0.45359237,
  toThisUnit: lbs => (lbs * 0.45359237) / 1000
};

const unitList = [Pounds, Kilograms, MetricTon];
export const MassUnits = {
  Pounds,
  Kilograms,
  MetricTon,
  options: buildOptions(unitList)
};
